export default {
    path: '/noticelist',
    meta: {
        title: '消息中心',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/noticelist`),
}


// WEBPACK FOOTER //
// ./src/views/NoticeList/router.js